import type { SavedPaymentMethodResponse } from "../types/generated";

export function formatSavedPaymentMethodExpiry(
  month: number,
  year: number,
): string | null {
  if (
    !Number.isInteger(month) ||
    month < 1 ||
    month > 12 ||
    !Number.isInteger(year) ||
    year < 1000 ||
    year > 9999
  ) {
    return null;
  }
  return `${String(month).padStart(2, "0")}/${year}`;
}

export function reconcileSavedPaymentMethodSelection(
  methods: readonly SavedPaymentMethodResponse[],
  currentId: string | null,
  initializeProviderDefault: boolean,
): string | null {
  if (
    currentId !== null &&
    methods.some(
      (method) => method.payment_method_id === currentId && method.is_usable,
    )
  ) {
    return currentId;
  }

  if (!initializeProviderDefault) return null;

  return (
    methods.find((method) => method.is_default && method.is_usable)
      ?.payment_method_id ?? null
  );
}

export function getSavedPaymentMethodUnavailableLabel(
  reason: SavedPaymentMethodResponse["unavailable_reason"],
): string | null {
  switch (reason) {
    case "expired":
      return "Expired";
    case "detached":
      return "No longer available";
    case "invalid_details":
      return "Card details need updating";
    case null:
      return null;
  }
}
